import { useContext } from 'react';
import { SocketContext } from 'contexts/socketio_context';

const useSocketIO = () => {
    return useContext(SocketContext);
};

export default useSocketIO;
